module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/ekanban@2x-342158de64d5e87467de64c22e8a05b0.png";